export const TIME_PATTERN = /^(0\d|1\d|2[0-8]):[0-5]\d$/;
